import { render, staticRenderFns } from "./BrickTimerDailyFrequencySettings.vue?vue&type=template&id=062bca8d&"
import script from "./BrickTimerDailyFrequencySettings.vue?vue&type=script&lang=js&"
export * from "./BrickTimerDailyFrequencySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('062bca8d')) {
      api.createRecord('062bca8d', component.options)
    } else {
      api.reload('062bca8d', component.options)
    }
    module.hot.accept("./BrickTimerDailyFrequencySettings.vue?vue&type=template&id=062bca8d&", function () {
      api.rerender('062bca8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickTimerDailyFrequencySettings.vue"
export default component.exports